import { MessagePlugin } from 'tdesign-react';

export const getUploadSpineObject = (urls: { resourceName: string, url: string }[]) => {
  const obj: {
    fileName: string;
    skel: string;
    atlas: string;
    json: string;
    images: string[];
  } = {
    fileName: '',
    skel: '',
    atlas: '',
    json: '',
    images: [],
  };

  urls?.forEach((item) => {
    if (item.resourceName?.toLowerCase()) {
      const fileName = item.resourceName.toLowerCase();
      // 骨骼动画相关文件
      if (fileName.endsWith('.skel.bytes') || fileName.endsWith('.skel')) {
        obj.skel = item.url;
        obj.fileName = fileName.replace('.skel.bytes', '').replace('.skel', '');
        console.log('发现骨骼动画文件:', item.resourceName);
      }
      // 纹理集相关文件
      if (fileName.endsWith('.atlas.txt') || fileName.endsWith('.atlas')) {
        obj.atlas = item.url;
        console.log('发现纹理集文件:', item.resourceName);
      }
      // 图片资源文件
      if (fileName.match(/\.(png|jpg|jpeg|webp)$/)) {
        obj.images.push(item.url);
        console.log('发现图片资源:', item.resourceName);
      }
      // JSON配置文件
      if (fileName.endsWith('.json')) {
        obj.json = item.url;
        console.log('发现配置文件:', item.resourceName);
      }
    }
  });
  if (obj.skel && obj.atlas && obj.images.length) {
    return obj;
  }
  MessagePlugin.error('请上传正确的骨骼动画【.skel.bytes】、纹理集【.atlas.txt】、图片资源');
  return {};
};
